import axios, { AxiosError } from "axios";
import { clearAuthAndRedirect } from "./axiosInstance";

/**
 * Client for authz-api (identity): /auth/config, /auth/userinfo, /auth/me/*.
 *
 * Same bearer token and 401 handling as the admin-api client, different base
 * URL. Login.tsx / Callback.tsx keep using raw fetch because they run before a
 * token exists.
 */
const authzInstance = axios.create({
  baseURL:
    process.env.REACT_APP_AUTH_URL || "https://authz-api.cms.chargingadda.com",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

authzInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

authzInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      clearAuthAndRedirect();
      return Promise.reject(new Error("Session expired"));
    }
    return Promise.reject(error);
  },
);

export default authzInstance;
